import { db } from '@/firebase/index'

const dbRanking = db.collection('ranking')

export default dbRanking



// WEBPACK FOOTER //
// ./src/firebase/ranking.js